// extracted by mini-css-extract-plugin
export default {"container":"TagBlock_container__vKXot","align-left":"TagBlock_align-left__FEXMg","align-center":"TagBlock_align-center__gukXv","align-right":"TagBlock_align-right__jZEZQ"};